export default {
  // nfcReadTxt(state) {
  //   return state.nfcReadTxt
  // },
  // nfcWriteTxt: state => {
  //   return state.nfcWriteTxt
  // },
  getShowPublish(state) {
    return state.showPublish
  },
  getIsCart(state) {
    return state.isCart
  },
  getOrderObj(state) {
    return state.orderStateObj
  },
  getTalkbaoIndex(state) {
    return state.talkbaoindex
  },
  getGuangguangIndex(state) {
    return state.guangguangindex
  },
  getImprintIndex(state) {
    return state.imprintindex
  },
  getShowUpdateNum(state) {
    return state.showUpdateNum
  },
  getFocusAddRemark(state) {
    return state.focusAddRemark
  },
  getUserInfo(state) {
    if (!state) {
      let localUser = localStorage.getItem('userinfo')
      if (localUser) {
        return localUser
      }
    }
    return state
  },
  getBoothStoreDetail(state) {
    return state.boothStoreDetail
  },
  getOrderKeyId(state) {
    return state.orderKeyId
  },
  getIGetSalesNum(state) {
    return state.iGetSalesNum
  },
  getIGetUpdateSalesNum(state) {
    return state.iGetUpdateSalesNum
  },
  getBmTab(state) {
    return state.bmTab
  },
  getBackWaitOrder(state) {
    return state.backWaitOrder
  },
  getAddRemarkText(state) {
    return state.addRemarkText
  },
  getAddRemarkObj(state) {
    return state.addRemarkObj
  },
  getVideoShow(state) {
    return state.videoShow
  },
  getVideoSrc(state) {
    return state.videoSrc
  },
  getHomePop(state) {
    return state.homePop
  },
  nfcReadtxt: state => {
    return state.nfcReadTxt
  },
  nfcWriteTxt: state => {
    return state.nfcWriteTxt
  },
  // getNum(state){
  //   state.swiperNum = JSON.parse(localStorage.getItem('swiperNum'))
  //   console.log('113231',state.swiperNum);
  //   return state.swiperNum
  // }
}


// WEBPACK FOOTER //
// ./src/store/getters.js